import { Component, OnInit, AfterViewInit, OnDestroy, Input, Output, EventEmitter, ViewChild} from '@angular/core';
 
import {  html_beautify  } from 'js-beautify';
import { ApiService } from 'app/services/api.service';

@Component({
  selector: 'app-lectionary-item-html-editor',
  templateUrl: './lectionary-item-html-editor.component.html',
  styleUrls: ['./lectionary-item-html-editor.component.css']
})
export class LectionaryItemHtmlEditorComponent implements OnInit {

 
  @Input() public textAreaValue: string;
  @Input() public isReadOnly: boolean = false;
  @Output() public valueChanged = new EventEmitter<string>();
  @ViewChild('codeeditor', { static: true }) private codeEditor; 

  private isReadyToUpdateValue : boolean;
 
  private iframePreviewElement : any;
  public cssUrl : any;

  //public divPreviewValue : any; 
     
  constructor(public apiSvc: ApiService) { 
    var url = this.apiSvc.baseUrl + "api/settings/getcss";  
    this.cssUrl = url; 
   }

  ngOnInit() {   
 
    this.isReadyToUpdateValue = false; 

    //Initialize the iframe contents with the stylesheet
    this.iframePreviewElement  = document.getElementById("iframePreview");   
    this.iframePreviewElement.srcdoc = "<html><link rel=\"stylesheet\" href=\"" + this.cssUrl + "\"><body><div id='divContentTarget' contenteditable='true' spellcheck='true'  class='defaultReadings'></div></body></html>";
 
    this.beautifyHtml(); 

    //console.log(this.codeEditor);
  }
 

  public ngAfterViewInit (){
    console.log("ngAfterViewInit"); 

    this.isReadyToUpdateValue = true;
   // this.updateIframe(this.textAreaValue);  
    this.codeEditor.codeMirror.on("inputRead", (e,f) => {this.inputRead(e,f)}); 
    this.codeEditor.codeMirror.on("beforeChange", (e,f) => {this.beforeChange(e,f)}); 


    console.log(this.codeEditor.codeMirror);

    // this.codeEditor.codeMirror.focus();
    // this.codeEditor.codeMirror.setCursor(this.codeEditor.codeMirror.lineCount(), 0);
    
    setTimeout(() => {   
 
      console.log("timeout");
      this.updateIframe(this.textAreaValue);  
     }, 1000);

  }


  //see https://codemirror.net/doc/manual.html
  //Listen for the paste event in order to reformat the HTML 
  public inputRead(editor: any, changeObj: any) {

    
    if (changeObj.origin == "paste") {
      console.log("Paste detected");
      this.beautifyHtml();
    } 

  }

  public beforeChange(editor: any, changeObj: any) {
 
    //console.log("beforeChange", editor, changeObj, this.isReadOnly);
    if (this.isReadOnly) { 
      changeObj.cancel(); 
      console.log("change prevented, editor is in read only mode");
    }

  }

  public cursorChange(e) { 

  
    if (this.isReadyToUpdateValue == false) return;

    var rawValue = e.getValue();   
  //   console.log("cursorChange", "textAreaValue", this.textAreaValue, "RAWVALUE", rawValue);
    var unsanitizedValue = rawValue + ""; 
  
    this.updateIframe(unsanitizedValue); 

    this.valueChanged.emit(unsanitizedValue);
  }

  private updateIframe(value: string) {
 
    var element = this.iframePreviewElement.contentWindow.document.getElementById("divContentTarget"); 
    //console.log(element);
    if (element == undefined) return;
    
    element.innerHTML = value;

  }

  public beautifyHtml() {
  
 
    this.textAreaValue = html_beautify(this.textAreaValue,{
      "indent_size": "1",
      "indent_char": "\t",
      "max_preserve_newlines": "5",
      "preserve_newlines": true,
      "keep_array_indentation": false,
      "break_chained_methods": false,
      "indent_scripts": "normal",
      "brace_style": "collapse",
      "space_before_conditional": true,
      "unescape_strings": false,
      "jslint_happy": false,
      "end_with_newline": false,
      "wrap_line_length": "0",
      "indent_inner_html": false,
      "comma_first": false,
      "e4x": false,
      "indent_empty_lines": false
    });

  }

  public ngOnDestroy() {
    console.log("ngOnDestroy");
    this.codeEditor.codeMirror.off("inputRead");
  }

}


